// set .name for anonymous default exports per ES spec
__webpack_require__.dn = function(x) {
	(Object.getOwnPropertyDescriptor(x, "name") || {}).writable || Object.defineProperty(x, "name", { value: "default", configurable: true });
};